<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane v-if="visibleAtributoCaracter" key="1">
      <span slot="tab">
        <a-icon type="snippets"/>
        Atributos caracter
      </span>
        <a-card>
          <attributo-caracter-numerico
            :empleadoseleccionado="empleadoseleccionado"
            :endpoint="endpointCaracter"
            @handleOk="handleOkCaracter"
          />
        </a-card>
        <a-tabs default-active-key="1">
          <a-tab-pane v-if="visibleAtributoNumerico" key="1">
          <span slot="tab">
              <a-icon type="clock-circle"/>
              Histórico
          </span>
            <a-card>
              <attributo-historico
                :empleadoseleccionado="empleadoseleccionado"
                :endpoint="endpointCaracterHist"
                ref="historicoCaracter"
              />
            </a-card>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
      <a-tab-pane key="2">
      <span slot="tab">
        <a-icon type="snippets"/>
        Atributos numéricos
      </span>
        <a-card>
          <attributo-caracter-numerico
            :empleadoseleccionado="empleadoseleccionado"
            :endpoint="endpointNumerico"
            @handleOk="handleOkNumerico"
          />
        </a-card>
        <a-tabs default-active-key="1">
          <a-tab-pane key="1">
          <span slot="tab">
              <a-icon type="clock-circle"/>
              Histórico
          </span>
            <a-card>
              <attributo-historico
                :empleadoseleccionado="empleadoseleccionado"
                :endpoint="endpoinNumericoHist"
                ref="historicoNumerico"
              />
            </a-card>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    props: ['empleadoseleccionado'],
    data () {
      return {
        endpointCaracter: 'emp_att_car',
        endpointCaracterHist: 'emp_att_car_hist',
        endpoinNumericoHist: 'emp_att_num_hist',
        endpointNumerico: 'emp_att_num'
      }
    },
    methods: {
      handleOkCaracter () {
        this.$refs.historicoCaracter.loadData()
      },
      handleOkNumerico () {
        console.log('Entro numerico')
        this.$refs.historicoNumerico.loadData()
      }
    },
    computed: {
      visibleAtributoCaracter () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_ATRIBUTOS_CARACTER')
        }
      },
      visibleAtributoNumerico () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_ATRIBUTOS_NUMERICOS')
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/AttributoTabs.vue